export enum AppointmentTypes {
  AGENCY = 'In Agenzia',
  SKYPE = 'Skype',
  WHATSAPP = 'WhatsApp',
  EMAIL = 'Email',
  TEL = 'Telefono'
}
